// removed by extract-text-webpack-plugin
module.exports = {"currency":"CurrencySelect-style__currency__68c5f967","currencyLink":"CurrencySelect-style__currencyLink__68c5f967","currencyWrap":"CurrencySelect-style__currencyWrap__68c5f967","currencySymbol":"CurrencySelect-style__currencySymbol__68c5f967","currencyList":"CurrencySelect-style__currencyList__68c5f967","checkmark":"CurrencySelect-style__checkmark__68c5f967","isActive":"CurrencySelect-style__isActive__68c5f967","arrowDown":"CurrencySelect-style__arrowDown__68c5f967","dropdownWrapper":"CurrencySelect-style__dropdownWrapper__68c5f967"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/CurrencySelect/CurrencySelect-style.scss
// module id = 4208
// module chunks = 62